<template>
  <page style="height: 100vh; overflow: hidden">
    <div class="home-warp">
      <div class="home-head">
        <img
          class="home-logo"
          src="../assets/imgs/icon_logo.png"
          alt=""
          @click="isMenuView = false"
        />
        <div class="home-head-title">
          <div class="home-head-title-small">{{ i18n.welcome }}</div>
          <div>{{ title }}</div>
        </div>
      </div>
      <div class="home-body">
        <DownloadApp></DownloadApp>
        <!-- <div class="btn home-btn" v-if="qrcode" @click="onScan">
          {{ i18n.next }}
        </div> -->
      </div>
    </div>
    <popup-warp v-model="isMenuView" dialogTransition="slide-left">
      <menu-side @close="isMenuView = false"></menu-side>
    </popup-warp>
  </page>
</template>

<script>
import { mapState } from "vuex";
import { PopupWarp } from "../components/popup";
import { MenuSide } from "../components/menu";
import { QR_CODE, ZH_CODE, ORDER_TEMP } from "../apis/cabinet";
import { USER_INFO, USER_CARD } from "../apis/user";

import { SAVED_CARD_TO_RENT, SAVED_CARD_RENT } from "../apis/payment";
import DownloadApp from "../components/download/downloadApp";

export default {
  components: {
    DownloadApp,
    PopupWarp,
    MenuSide
  },
  computed: {
    ...mapState([
      "qrcode",
      "zhcode",
      "cabinet",
      "browser",
      "user",
      "token",
      "system"
    ]),
    i18n() {
      return this.$t("home");
    },
    i18nMsg() {
      return this.$t("msg");
    },
    title() {
      return process.env.VUE_APP_NAME;
    },
    code() {
      return this.qrcode || this.zhcode;
    },
    scanUrl() {
      if (this.qrcode) {
        return `${QR_CODE}?id=${this.qrcode}&usePriceUnit=true`;
      }
      return "";
    },
    banner() {
      return this.cabinet && this.cabinet.shoplogo
        ? `background-image: url(${this.cabinet.shoplogo});`
        : "";
    },
    shopDesc() {
      return `${this.i18n.price_info}`.format({
        ...this.cabinet,
        fengding: this.$moneyFormat(this.cabinet.fengding),
        yajin: this.$moneyFormat(this.cabinet.yajin),
        appName: process.env.VUE_APP_NAME
      });
    },
    shopDesc0() {
      return `${this.i18n.price_info_0}`.format({});
    },
    shopDesc1() {
      return `${this.i18n.price_info_1}`.format({
        ...this.cabinet,
        ...this.cabinet.priceStrategy
      });
    },
    shopDesc2() {
      return `${this.i18n.price_info_2}`.format({
        email: process.env.VUE_APP_EMAIL,
        appName: process.env.VUE_APP_NAME
      });
    },
    shopTips1() {
      return `${this.i18n.tips_1}`.format(this.cabinet);
    },
    shopTips2() {
      return `${this.i18n.tips_2}`.format(this.cabinet);
    },
    shopTips3() {
      return `${this.i18n.tips_3}`.format(this.cabinet);
    },
    homebg() {
      return `${process.env.VUE_APP_DOMAIN}/content/introduction1.png`;
    },
    amount() {
      if (this.cabinet) {
        const { yajin, myyue, overtimeAmount } = this.cabinet;
        let _amount = yajin.toFixed(2);
        if (yajin <= 0 && overtimeAmount <= 0) {
          _amount = (yajin - myyue).toFixed(2);
        }
        return _amount;
      } else {
        return 0;
      }
    },
    priceStrategy() {
      return this.cabinet && this.cabinet.priceStrategy;
    }
  },
  data() {
    return {
      isMenuView: false,
      isScan: false,
      isBtns: false,
      checked: true,
      adVisible: false,
      downloadApp: false,
      downType: "",
      cardList: [], // 支付的卡列表
      productId: "",
      productList: []
    };
  },
  methods: {
    Download(str) {
      this.downloadApp = true;
      this.downType = str;
    },
    onDownload() {
      let dowmloadUrl = process.env.VUE_APP_GOOGLE_PLAY;
      if (this.system === "ios") {
        dowmloadUrl = process.env.VUE_APP_APP_STORE;
      }
      if (dowmloadUrl) {
        window.open(dowmloadUrl);
      } else {
        this.$toast(this.i18nMsg.appoffline);
      }
    },
    onScan() {
      if (!this.scanUrl) return;
      this.$loading(true);
      this.$post(
        this.scanUrl,
        {},
        resp => {
          this.$loading(false);
          this.$store.commit("cabinet", {
            qrcode: this.code,
            ...resp
          });
          if (resp.zujieNum && resp.zujieNum > 0) {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: `${this.i18n.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.vieworder,
              cancelText: this.i18nMsg.cancel
            })
              .then(() => {
                this.$router.push("/order");
                // this.$store.commit("qrcode", "")
              })
              .catch(() => {
                // this.$store.commit("qrcode", "")
              });
          } else {
            this.isScan = true;
            this.getProduct();
          }
        },
        error => {
          this.$loading(false);
          this.$toast(error);
        }
      );
    },
    onSubmit() {
      if (this.productId) {
        let temp = this.productList.find(e => e.productId === this.productId);
        this.$store.commit("cabinet", temp);
      }
      let myyue = this.cabinet.myyue;
      let yajin = 0.0;
      let overtimeAmount = 0.0;
      if (
        this.cabinet.priceStrategy != null &&
        this.cabinet.priceStrategy.pId != null
      ) {
        yajin = this.cabinet.priceStrategy.pDepositAmount;
        overtimeAmount = this.cabinet.priceStrategy.pOvertimeAmount;
      } else {
        yajin = this.cabinet.yajin;
        overtimeAmount = this.cabinet.overtimeAmount ?? this.cabinet.yajin;
      }
      if (myyue >= yajin && myyue >= overtimeAmount) {
        this.onBorrow();
      } else if (yajin === 0 && overtimeAmount > 0) {
        if (this.cardList && this.cardList.length > 0) {
          this.saveToRent();
        } else {
          this.$router.push({
            path: "/payment_card",
            query: { payType: "YJ", qrcode: this.cabinet.qrcode }
          });
        }
      } else if (yajin > 0 && overtimeAmount > 0 && overtimeAmount > yajin) {
        if (this.cardList && this.cardList.length > 0) {
          this.$router.push({
            path: "/confirm",
            query: { price: this.amount, payType: "YJ" }
          });
        } else {
          this.$router.push({
            path: "/payment_card",
            query: { payType: "YJ", qrcode: this.cabinet.qrcode }
          });
        }
      } else {
        this.$router.push({
          path: "/confirm",
          query: { price: this.amount, payType: "YJ" }
        });
      }
    },
    onCardBorrow() {
      this.$loading(true);
      this.$get(
        `${SAVED_CARD_RENT}?qrcode=${this.cabinet.qrcode}`,
        {},
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data.out_trade_no) {
            this.$router.push(`/result?tradeNo=${resp.data.out_trade_no}`);
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            });
          }
        },
        error => {
          this.$loading(false);
          this.$toast(error);
        }
      );
    },
    onBorrow() {
      this.$loading(true);
      this.$get(
        // `${ORDER_TEMP}/${this.cabinet.qrcode}/paypal`,
        `${ORDER_TEMP}?qrcode=${this.cabinet.qrcode}&rentalProductType=${this.productId}`,
        {},
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data.outTradNo) {
            this.$router.push(
              `/result?tradeNo=${resp.data.outTradNo}&shopid=${this.cabinet.shopid}`
            );
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            });
          }
        },
        error => {
          this.$loading(false);
          console.log(error);
          this.$toast(error);
        }
      );
    },
    loadUser() {
      this.$get(
        USER_INFO,
        {},
        resp => {
          if (resp.user) {
            this.$store.commit("user", resp.user);
            this.onScan();
          } else {
            this.$store.commit("user", null);
          }
        },
        error => {
          this.$store.commit("user", null);
          console.log(error);
        }
      );
    },
    onAppStore() {
      console.log("11111");
      window.open(process.env.VUE_APP_APP_STORE);
      // window.location.href = process.env.VUE_APP_APP_STORE
    },
    onGooglePlay() {
      console.log("22222");
      window.open(process.env.VUE_APP_GOOGLE_PLAY);
      // window.location.href = process.env.VUE_APP_GOOGLE_PLAY
    },
    onCode() {
      this.isBtns = false;
      this.loadUser();
    },
    onEntrust() {
      console.log("test", process.env.VUE_APP_DOMAIN_NAME);
      window.location.href = `${process.env.VUE_APP_DOMAIN_NAME}/content/wxf_auth.html`;
    },
    goNearby() {
      this.$router.push("./google_map");
    },
    setDocumentTitle(title) {
      document.title = title;
      if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        var i = document.createElement("iframe");
        i.src = "/favicon.ico";
        i.style.display = "none";
        i.onload = function() {
          setTimeout(function() {
            i.remove();
          }, 9);
        };
        document.body.appendChild(i);
      }
    },
    // 获取用户支付卡信息
    async getUserPayCard() {
      this.$loading(true);
      const qrcode = this.qrcode || (this.cabinet && this.cabinet.qrcode);
      const { data = [] } = await this.$Request("get", USER_CARD, {
        qrcode,
        orderId: "",
        agentld: this.agentId
      })
        .catch(error => {
          this.$loading(false);
          console.log(error);
        })
        .finally(() => {
          this.$loading(false);
        });
      let cardList = [];
      if (data && data.length) {
        cardList = data.map(item => {
          return {
            phone: "all",
            label: item.pCardnumber,
            ...item.paymentConfig,
            ...item
          };
        });
        this.cardList = cardList;
      }
      // this.$loading(false)
      return cardList;
    },
    saveToRent() {
      this.$loading(true);
      this.$get(
        `${SAVED_CARD_TO_RENT}`,
        {
          qrcode: this.cabinet.cabinetID || this.$route.query.qrcode,
          rentalProductType: this.productId
        },
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data && resp.data.out_trade_no) {
            this.$router.replace(
              `/result?&payMode=${this.payMode}&tradeNo=${resp.data.out_trade_no}`
            );
          }
        },
        error => {
          this.$loading(false);
          console.log(error);
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    },
    onPaymentAgreement() {
      window.open("https://m.chargi.ba/content/payment_agreement.html");
    },
    async getProduct() {
      this.$loading(true);
      let isProduct1 =
        this.cabinet.supportRentalProductType != null &&
        this.cabinet.supportRentalProductType.toString().includes("1") &&
        this.cabinet.ordinaryPowerBankAvailable;
      let isProduct2 =
        this.cabinet.supportRentalProductType != null &&
        this.cabinet.supportRentalProductType.toString().includes("2") &&
        this.cabinet.fastChargePowerBankAvailable;
      let type = "";
      if (isProduct1 && isProduct2) {
        type = this.cabinet.defaultRentalProductType;
      } else if (isProduct2) {
        type = "2";
      } else if (isProduct1) {
        type = "1";
      }
      let url = `${QR_CODE}?id=${this.cabinet.qrcode}&usePriceUnit=true&rentalProductType=${type}`;
      const data = await this.$Request("post", url, {})
        .catch(error => {
          this.$loading(false);
          console.log(error);
        })
        .finally(() => {
          this.$loading(false);
        });
      if (data) {
        this.$store.commit("cabinet", {
          ...data,
          productId: type
        });
        this.$router.push("/borrow");
      }
    }
  },
  created() {
    console.log("类型", this.browser, "1");
    if (this.$route.query && this.$route.query.cabinetshow === "true") {
      // this.isScan = true
      // this.isBtns = false
      // this.adVisible = true
      // if (this.cabinet) {
      //   this.productList = []
      //   let isProduct1 = this.cabinet.supportRentalProductType != null && this.cabinet.supportRentalProductType.includes('1') && this.cabinet.ordinaryPowerBankAvailable;
      //   let isProduct2 = this.cabinet.supportRentalProductType != null && this.cabinet.supportRentalProductType.includes('2') && this.cabinet.fastChargePowerBankAvailable;
      //   if (isProduct1 && isProduct2) {
      //     this.getProduct("2");
      //     this.getProduct("1");
      //     this.productId = this.cabinet.defaultRentalProductType
      //   } else if (isProduct2) {
      //     this.getProduct("2");
      //     this.productId = "2"
      //   } else if (isProduct1) {
      //     this.getProduct("1");
      //     this.productId = "1"
      //   } else {
      //     this.productList.push({
      //       ...this.cabinet,
      //       'productName': '6000mAh',
      //       'productId': ''
      //     })
      //     this.productId = ""
      //   }
      // }
    }
  }
};
</script>

<style lang="less">
.home-warp {
  width: 100%;
  height: 100vh;
  background-color: #000;
  display: flex;
  flex-direction: column;
  .home-head {
    padding: 56px 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .home-logo {
      width: 126px;
    }
    .home-head-title {
      text-align: right;
      color: #fff;
      font-size: 36px;
      .home-head-title-small {
        font-size: 24px;
      }
    }
  }
  .home-body {
    flex: 1;
    border-radius: 106px 106px 0 0;
    background-color: #fff;
    background-image: url("../assets/imgs/home_bg.png");
    background-size: 100%;
    background-repeat: no-repeat;
    padding: 82px 48px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .home-btn {
      margin-top: 20px;
    }
  }
}
</style>
